import { figureParts } from "@/lib/tool-kit/games-organizers/hangman";

const STROKE = 5;

/** The gallows, always drawn, and the figure, one stroke per share of the misses allowed. */
export default function HangmanFigure({
  misses,
  maxMisses,
  label,
}: {
  misses: number;
  maxMisses: number;
  label: string;
}) {
  const parts = figureParts(misses, maxMisses);
  const line = {
    stroke: "currentColor",
    strokeWidth: STROKE,
    strokeLinecap: "round" as const,
    fill: "none",
  };
  return (
    <svg
      aria-label={label}
      className="mx-auto block h-auto w-full max-w-[16rem] text-foreground"
      role="img"
      viewBox="0 0 200 240"
    >
      <path d="M20 230H120M50 230V20H140V50" {...line} opacity={0.55} />
      {parts >= 1 ? <circle cx={140} cy={68} r={18} {...line} /> : null}
      {parts >= 2 ? <path d="M140 86V150" {...line} /> : null}
      {parts >= 3 ? <path d="M140 100L115 130" {...line} /> : null}
      {parts >= 4 ? <path d="M140 100L165 130" {...line} /> : null}
      {parts >= 5 ? <path d="M140 150L118 195" {...line} /> : null}
      {parts >= 6 ? <path d="M140 150L162 195" {...line} /> : null}
    </svg>
  );
}
